import { assignProps } from '@/utils/resultsHelper';
import fieldNames from '@/constants/fields';
import withDraft from '@/utils/draftHelper';
import { pruneFormFieldErrors } from '@/forms/state/state';
import updateMultiplePanels from '@/utils/panels';
import { datasetCatalogueActions, datasetSteps } from '../constants';
import { assignEditProps, markDatasetAsDirty } from './state';
import findDataset from './shared';

const updateDatasetCatalogue = (draft, {
  category,
  code,
  template,
  properties,
  fields,
  entity,
}, step) => {
  const item = findDataset(draft, { category, code });

  assignEditProps(item, template);
  assignProps(item, { catalogue: properties });
  markDatasetAsDirty(item, step);
  item.saveErrors = pruneFormFieldErrors(item.saveErrors, { fields, entity });
};

const updateDatasetCatalogueTitle = withDraft((draft, action) => {
  updateDatasetCatalogue(draft, {
    ...action,
    properties: { title: action.value },
    fields: [fieldNames.NAME],
    entity: 'catalogue',
  }, datasetSteps.START);
});

const updateDatasetCatalogueProperties = withDraft((draft, action) => {
  updateDatasetCatalogue(draft, action, datasetSteps.FIRST_SECTION);
});

const updateCataloguePanels = withDraft((draft, action) => {
  const item = findDataset(draft, action);
  item.panels[action.panel] = updateMultiplePanels(item, action);
});

export default {
  [datasetCatalogueActions.UPDATE_CATALOGUE_PANELS]: updateCataloguePanels,
  [datasetCatalogueActions.UPDATE_DATASET_CATALOGUE_PROPERTIES]: updateDatasetCatalogueProperties,
  [datasetCatalogueActions.UPDATE_DATASET_CATALOGUE_TITLE]: updateDatasetCatalogueTitle,
};
